import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Modal from "../../../../../components/Modals/ModalComponent";
import CreatePlayer from '../../../../../components/EngageComponents/PlayersComponent/Modals/CreatePlayer'
import addIcon from '../../../../../media/images/icons/light.png'

const Control = ({className, type, width, action}) => {

  const [visibleModal, setVisibleModal] = useState(false);

  const actions = [
    {
      icon: "add",
      action: () => setVisibleModal(true),
    }
  ];

  return (
    <>
      <div className={cn(styles.control, className)}>
        {actions.map((x, index) => (
            <div className={styles.createButton} onClick={x.action}>
              <Link className={type == 'small' ? cn("button-tiny", styles.button) : cn("button-small", styles.button)}><img className={styles.addIcon} src={addIcon} action={x.action} alt='gamehub_add_icon'width={20} height={20}/>{type == 'medium' ? 'Create Player' : 'Create' }</Link>
            </div>
        ))}
      </div>
      <Modal width='small' visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <CreatePlayer action={action} onClose={() => setVisibleModal(false)}/>
      </Modal>
    </>
  );
};

export default Control;
